import { render, staticRenderFns } from "./AlarmConfig.vue?vue&type=template&id=db86b058&"
import script from "./AlarmConfig.vue?vue&type=script&lang=js&"
export * from "./AlarmConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AlarmConfig.vue"
export default component.exports